export const chinese = {
  // Language selection
  language: "语言",
  thai: "泰语",
  english: "英语",
  chinese: "中文",
  
  // Button labels
  save: "保存",
  saveColumns: "保存列",
  search: "搜索",
  clear: "清除",
  add: "添加",
  edit: "编辑",
  delete: "删除",
  cancel: "取消",
  ok: "确定",
  close: "关闭",
  
  // Column headers and labels commonly used in shipping
  customer: "客户",
  jobNo: "工作编号",
  containerNo: "集装箱号",
  booking: "订舱",
  etd: "预计离港",
  eta: "预计到港",
  status: "状态",
  invoice: "发票",
  shippingProcess: "运输流程",
  import: "进口",
  export: "出口",
  
  // Filter labels
  filter: "筛选",
  searchNumber: "搜索号码",
  searchValue: "搜索值",
  noFilter: "未指定",
  notSpecified: "未指定",
  
  // Messages
  saveSuccess: "列保存成功",
  searchRequired: "请输入至少1个搜索条件",
  
  // Shipping specific terms
  blReceived: "收到提单",
  enterMBL: "输入主提单",
  freightInvoice: "运费发票",
  doReceived: "收到交货单",
  customsForm: "草拟报关单",
  customsClear: "准备清关",
  
  // Navigation
  jumpToDO: ">>收到交货单>>",
  jumpToCustomsClear: ">>清关>>",
  jumpToIssue: ">>问题>>",

  // Shipping column names
  Service: "服务",
  CusAbbr: "客户代码",
  IP_InvNo: "发票号码",
  IP_InvDte: "发票日期",
  Bkg: "订舱",
  IP_Csgn: "收货人",
  IP_ETD: "预计离港",
  Note: "备注",
  IP_PO: "采购订单",
  IP_PoL: "装货港",
  IP_PoD: "卸货港",
  PLCreTm: "装箱单接收时间",
  OwnAccId: "装箱单发送者",
  OwnAccNm: "装箱单发送者",
  OwnAccEmail: "装箱单发送者邮箱",
  EDCreTm: "报关单草稿创建时间",
  EDCreAccId: "报关单创建者",
  EDCreAccNNm: "报关单创建者",
  EDNo: "报关单号",
  EDAprvTm: "报关单批准时间",
  EDSndTm: "报关单发送时间",
  EDCfTm: "报关单确认时间",
  ED0209CreTm: "0209创建时间",
  ED0209SndTm: "0209发送时间",
  ED0309CreTm: "0309创建时间",
  ED0309SndTm: "0309发送时间",
  ED0409CreTm: "0409创建时间",
  ED0409SndTm: "0409发送时间",
  CDCreTm: "集装箱申报单创建时间",
  CDCreAccId: "集装箱申报单创建者",
  CDCreAccNNm: "集装箱申报单创建者",
  CDAprvTm: "集装箱申报单批准时间",
  CDSndTm: "集装箱申报单发送时间",
  PayCstmTm: "海关付款时间",
  Rmk: "备注",
  GrossWt: "毛重",
  TotalGW: "总毛重",
  CT: "包装数量(CT)",
  KGM: "包装重量(KGM)",
  M3: "体积(M3)",
  Vol: "集装箱数量",
  TotalKGM: "验证毛重",
  ShpTypId: "车辆类型",
  Cnee: "收货人",
  CneeNm: "收货人",
  CneeSNm: "收货人",
  BLRecvTm: "提单接收时间",
  InvPLTm: "发票/装箱单接收时间",
  BLCfTm: "分提单确认时间",
  BLSndTm: "分提单发送时间",
  ANRecvTm: "通知接收时间",
  MBLRecvTm: "主提单接收时间",
  MBLEntrTm: "主提单录入时间",
  FrtInvTm: "运费发票时间",
  FrtInvPaidTm: "运费付款时间",
  DOMailTm: "交货单邮件发送时间",
  DORecvTm: "交货单接收时间",
  CstmFormDfTm: "报关单草稿",
  CstmFormCfTm: "报关单确认",
  CstmClrTm: "清关日期",
  BLSts: "工作状态",
  DemFreeTm: "滞港免费时间",
  DemStDte: "滞港开始日期",
  DetFreeTm: "滞箱免费时间",
  DetStDte: "滞箱开始日期",
  ContNos: "提单中的集装箱号",
  ContNoStr: "提单中的集装箱号",
  ManAccNNm: "运输",
  ManAccNNmCS: "客服",
  ManAccNNmDoc: "单证",
  ManAccNNmSugg: "推荐人",
  ManAccNNmSale: "销售",
  ManAccId: "运输",
  ManAccIdCS: "客服",
  ManAccIdDoc: "单证",
  ManAccIdSugg: "推荐人",
  ManAccIdSale: "销售",
  SealContTm: "集装箱封箱日期",
  ScId: "雇佣运输",
  FormTm: "表格时间",
  DocSndTm: "文件发送时间",
  Brnd: "品牌",
  IssuId: "问题",
  IssuNm: "问题",
  ShpRunSt: "出发时间",
  ShpRunEn: "收到卡片时间",
  ShpInvServNm: "服务",
  ShpContNos: "提单中的集装箱号码",

  // Issue columns
  Prty: "优先级",
  Clr: "问题颜色",
  IssuTm: "问题时间",
  Dscp: "问题描述",
  IsFix: "已修复",

  // Additional terms
  addInvoice: "添加发票",
  linkInvoice: "关联发票",
  issueTable: "问题表",
  responsible: "负责人",
  hireShipping: "雇佣运输",
  notHireShipping: "不雇佣运输",
  hireShippingStatus: "雇佣状态",
  truckStatus: "卡车状态",
  notNotifiedTruck: "未通知卡车",
  truckNotified: "已通知卡车",
  noContainerPicture: "无集装箱照片",
  hasContainerPicture: "有集装箱照片",
  noContainerNumber: "无集装箱号",
  notArrivedFactory: "未到达工厂",
  shippingStatus: "运输状态",
  workNotFinished: "工作未完成",
  appointmentDate: "预约日期",

  // Additional shipping terms
  truckHead: "牵引车头",
  containerCount: "集装箱数量",
  truckNotification: "通知卡车",
  print: "打印",
  notifyCustomer: "通知客户",
  gotContainerNumber: "获得集装箱号",
  arrivedFactory: "到达工厂",
  workCompleted: "工作完成",
  containerPictures: "集装箱照片",
  sequenceNumber: "序号",
  files: "文件",
  documentsComplete: "文件齐全",
  No: "编号",
  RecvDocDte: "工作接收时间",
  IsOwnTuk: "使用CTT卡车",
  notIsOwnTuk: "不使用CTT卡车",
}